import logo from "../../assets/Gold-Logo.gif";
const Header = () => {
  return (
    <header className="bg-[#142a13] shadow-md sm:py-4 py-3 flex justify-center">
      <img src={logo} alt="Company Logo" className="sm:h-[70px] h-[60px] w-auto" />
    </header>
  );
};
export default Header;
